
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...wordpressInsuranceFR]",
      function () {
        return require("private-next-pages/[...wordpressInsuranceFR].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...wordpressInsuranceFR]"])
      });
    }
  